module.exports = __webpack_public_path__ + "img/bingo_ball-16.af17dcf7.png";